import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup
} from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

export interface IFormControl {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
}

export const FormControlStyled = styled(FormControl)<IFormControl>`
  && {
    margin-top: ${({ marginTop }) => marginTop};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-right: ${({ marginRight }) => marginRight};
  }
`
export const RadioGroupStyled = styled(RadioGroup)``
export const FormControlLabelStyled = styled(FormControlLabel)``
export const RadioStyled = styled(Radio)``

export const InputLabelCustom = styled(InputLabel)`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${COLORS.black};
  font-family: Arial;
`
